import React from "react";
import R14, {
  View,
} from "../core";
import { commonStyles } from "../assets/css/commonStyle";
import LinkPayerComponent from "../components/LinkPayerComponent";

export default R14.connect(
  class LinkPayerScreen extends React.Component {

    render() {
      return (
            <View style={[commonStyles.marginBottom16, commonStyles.dashboardScrollView, commonStyles.flex1]}>
              <LinkPayerComponent />
            </View>
      );
    }
  }
);
